export const arabicToPersian = (text) => {
  const arabicChars = {
    'ي': 'ی',  // Arabic "yeh" to Persian "yeh"
    'ك': 'ک',  // Arabic "keh" to Persian "keh"
    'ﻻ': 'لا', // Arabic "la" to Persian "la"
    'هٔ': 'ۀ', // Arabic "heh hamza" to Persian "heh"
  };

  // Loop through the text and replace Arabic characters with Persian ones
  return text.replace(/ي|ك|ﻻ|هٔ/g, function(matched) {
    return arabicChars[matched];
  });
}


export const persianToArabic = (text) => {
  const persianChars = {
    'ی': 'ي',
    'ک': 'ك'
  };

  return text.replace(/ی|ک|/g, function(match) {
    return persianChars[match] || match;
  });
}
